import { CustomQueryOptions } from '@/app/common/types_and_interfaces'
import { queryOptions } from '@tanstack/react-query'
import { providerPermissionManagementApi } from './api'
import { PROVIDER_PERMISSION_MANAGEMENT_KEYS } from './keys'
import { ProviderUser, ProviderUserRole } from './schema'

export class ProviderPermissionManagementQueries {
  public static getProviderUsers(
    providerId: string,
    options: CustomQueryOptions<ProviderUser[]> = {}
  ) {
    return queryOptions({
      queryKey: PROVIDER_PERMISSION_MANAGEMENT_KEYS.PROVIDER_USERS(providerId),
      queryFn: () =>
        providerPermissionManagementApi.getProviderUsers(providerId),
      ...options,
    })
  }

  public static getAllRoles(
    options: CustomQueryOptions<ProviderUserRole[]> = {}
  ) {
    return queryOptions({
      queryKey: PROVIDER_PERMISSION_MANAGEMENT_KEYS.GET_ALL_ROLES(),
      queryFn: () => providerPermissionManagementApi.getAllRoles(),
      ...options,
    })
  }
}
